<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow, }"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog">
            <div class="modal-content" style="border-radius: 20px">
<!--               <button type="button" class="close" style="position: absolute; right: 15px;top:7px; color: #fff; opacity: 0.9;z-index:1;" @click="onModalClose">-->
<!--                   <span aria-hidden="true">×</span>-->
<!--                </button>-->
                <!--  -->
                <img class="close-img" @click="onModalClose" :src="`${imgUrl}/cruiseDetail/suite/suite-modal-close.png`"/>
                <!-- <img class="close-img" @click="onModalClose" :src="`${currImgUrl}closeIconPop.png`"/> -->
                <div class="modal-body">
                    <img :src="suiteImage" style="border-radius: 10px"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SuiteStateroomPopup",
    props: {
        isShow: {
            type: Boolean
        },
        suiteImage: {
            type: String
        }
    },
    data () {
        return {
            isShowModal: false,
            currImgUrl: process.env.VUE_APP_IMG_URL + '/wechatMiniProgram/routesDetail/housingSelection/',
            imgUrl: process.env.VUE_APP_IMG_URL
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal {
    overflow-y: auto;
}
.modal-body {
    padding: 0px;
    img {
        width: 100%;
    }
}
.modal-dialog {
    top: 20px;
    width: 800px !important;
}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
.close-img {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
  height: 26px;
  width: 26px;
  cursor: pointer;
  border-radius: 26px;
}
.close-img:active {
  opacity: .8;
}
</style>